/** @jsx jsx */
import { jsx } from "theme-ui"
import PropTypes from "prop-types"

import { ab } from "../theme"
import Img from "gatsby-image/withIEPolyfill"
import Link from "./link"

const LogoGalleryItem = ({
  image,
  alt,
  link,
  linkTarget,
  currentLanguage,
  seoLinks,
}) => (
  <div
    sx={{
      width: ab({ _: "50%", md: "25%" }),
      display: "inline-block",
      verticalAlign: "middle",
      p: 3,
    }}
  >
    <Link
      to={link}
      target={linkTarget}
      language={currentLanguage}
      seoLinks={seoLinks}
    >
      <Img
        fixed={image}
        alt={alt}
        objectFit="contain"
        imgStyle={{ position: "relative" }}
        placeholderStyle={{ display: "none" }}
        style={{ width: "100%", height: "auto" }}
      />
    </Link>
  </div>
)

LogoGalleryItem.defaultProps = {
  seoLinks: {},
}

LogoGalleryItem.propTypes = {
  image: PropTypes.object.isRequired,
  link: PropTypes.string.isRequired,
  linkTarget: PropTypes.string,
  alt: PropTypes.string,
  currentLanguage: PropTypes.oneOf(["", "de", "en"]),
  seoLinks: PropTypes.object,
}

export default LogoGalleryItem
